import React, { useState } from 'react';
import axios from 'axios';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [resetToken, setResetToken] = useState('');

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/auth/forgot-password`, {
        email
      });

      setMessage(response.data.message);
      
      // For development: show reset token
      if (response.data.reset_token) {
        setResetToken(response.data.reset_token);
      }
      
      setLoading(false);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to process request');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full">
        <h1 className="text-3xl font-bold text-gray-800 mb-2" style={{ fontFamily: 'IBM Plex Serif, serif' }}>
          Forgot Password?
        </h1>
        <p className="text-gray-600 mb-6" style={{ fontFamily: 'IBM Plex Serif, serif' }}>
          Enter your email address and we'll help you reset your password.
        </p>

        {message && (
          <div className="bg-green-50 border border-green-200 rounded p-4 mb-4">
            <p className="text-green-800 text-sm" style={{ fontFamily: 'IBM Plex Serif, serif' }}>
              {message}
            </p>
            {resetToken && (
              <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded">
                <p className="text-xs text-yellow-800 mb-2" style={{ fontFamily: 'IBM Plex Serif, serif' }}>
                  <strong>Development Mode:</strong> Copy this token
                </p>
                <input
                  type="text"
                  value={resetToken}
                  readOnly
                  className="w-full px-2 py-1 text-xs bg-white border rounded font-mono"
                  onClick={(e) => e.target.select()}
                />
                <a
                  href={`/reset-password?token=${resetToken}`}
                  className="block mt-2 text-center bg-blue-600 text-white py-2 rounded hover:bg-blue-700 text-sm"
                  style={{ fontFamily: 'IBM Plex Serif, serif' }}
                >
                  → Reset Password Now
                </a>
              </div>
            )}
          </div>
        )}

        {error && (
          <div className="bg-red-50 border border-red-200 rounded p-4 mb-4">
            <p className="text-red-800 text-sm" style={{ fontFamily: 'IBM Plex Serif, serif' }}>
              {error}
            </p>
          </div>
        )}

        {!message && (
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2" style={{ fontFamily: 'IBM Plex Serif, serif' }}>
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-gray-800"
                style={{ fontFamily: 'IBM Plex Serif, serif' }}
                placeholder="your@email.com"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gray-800 text-white py-3 rounded hover:bg-gray-900 transition-all disabled:opacity-50 font-semibold"
              style={{ fontFamily: 'IBM Plex Serif, serif' }}
            >
              {loading ? 'Processing...' : 'Send Reset Link'}
            </button>
          </form>
        )}

        <div className="mt-6 text-center">
          <a
            href="/"
            className="text-blue-600 hover:underline text-sm"
            style={{ fontFamily: 'IBM Plex Serif, serif' }}
          >
            ← Back to Login
          </a>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
